import { z } from 'zod';

export const OrderCancelledEvent = z.object({
    orderId: z.string().uuid(),
    lineItemCount: z.number().default(0),
});

export type OrderCancelledEventPayload = z.infer<typeof OrderCancelledEvent>;
